import { useState, useCallback, useMemo } from "react";
import emailMisspelled, { top100 } from "email-misspelled";

export function useEmailSuggestion() {
  const [suggestion, setSuggestion] = useState(null);
  const checker = useMemo(
    () => emailMisspelled({ domains: top100, maxMisspelled: 2 }),
    [],
  );

  const checkEmail = useCallback(
    (email) => {
      if (!email || !email.includes("@")) {
        setSuggestion(null);
        return;
      }
      const results = checker(email);
      setSuggestion(results.length > 0 ? results[0].corrected : null);
    },
    [checker],
  );

  const clearSuggestion = useCallback(() => {
    setSuggestion(null);
  }, []);

  return { suggestion, checkEmail, clearSuggestion };
}
